import { Controller } from '@hotwired/stimulus'
import { Dropdown } from 'bootstrap'

export default class ClientPreviewController extends Controller {
  static targets = ['toggle', 'menu', 'link']

  connect() {
    this.dropdown = new Dropdown(this.toggleTarget)
    if (this.dropdown._menu === undefined) this.dropdown._menu = this.menuTarget

    this.toggleTarget.addEventListener('mouseover', this.onMouseover)
    this.toggleTarget.addEventListener('mouseleave', this.onMouseleave)

    this.menuTarget.addEventListener('mouseover', this.onMouseover)
    this.menuTarget.addEventListener('mouseleave', this.onMouseleave)

    if (this.hasLinkTarget) {
      this.linkTarget.addEventListener('click', this.goToLink)
    }
  }

  goToLink = event => {
    Turbo.visit(event.target.href)
  }

  onMouseover = event => {
    setTimeout(() => {
      if (this.dropdown._menu.contains(event.target) || this.dropdown._element.contains(event.target)) {
        this.dropdown.show()
      }
    }, 250)
  }

  onMouseleave = () => {
    setTimeout(() => {
      if (!this.isHovering()) {
        this.dropdown.hide()
      }
    }, 250)
  }

  isHovering() {
    return this.dropdown._menu.matches(':hover') || this.dropdown._element.matches(':hover')
  }

  disconnect() {
    this.toggleTarget.removeEventListener('mouseover', this.onMouseover)
    this.toggleTarget.removeEventListener('mouseleave', this.onMouseleave)
    this.menuTarget.removeEventListener('mouseover', this.onMouseover)
    this.menuTarget.removeEventListener('mouseleave', this.onMouseleave)
    this.dropdown.dispose()

    if (this.hasLinkTarget) {
      this.linkTarget.removeEventListener('click', this.goToLink)
    }
  }
}
